module.exports = __webpack_public_path__ + "static/media/accept-attestation.f94a7206.svg";